import { query } from "./strapi";

export function getCategoryPage(categoryUrl: string) {
  return query(`categories/${categoryUrl}`)
    .then((res) => {
      console.log("🔍 Category API Response:", res); // Debug log
      console.log("🔍 Category Data:", res?.data); // Debug log
      console.log("🔍 SEO Data received:", res?.data?.seo); // Debug SEO specifically
      return res?.data || {}; // Return the data directly or an empty object if null
    })
    .catch((err) => {
      console.error("Error fetching category page:", err);
      return {}; // Return an empty object in case of error
    });
}
